import { Controller } from 'stimulus';
import { initTooltips } from 'ez-styles/assets/js/utils/tooltips';

export default class LicenseCompareModalController extends Controller {
  connect() {
    if (this.element.querySelectorAll('.ez-tooltip-icon').length > 0) {
      initTooltips();
    }
  }
}
